import { ArrowRight } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

const ExploreSolutionsAlert = () => {
  const onExploreSolutions = () => window.open('https://codekeeper.co/solutions', '_blank');

  return (
    <Alert className="bg-secondary-foreground items-center py-4 px-6 gap-2 mb-6 grid-cols-[1fr_auto]">
      <div className="space-y-1">
        <AlertTitle className="text-base font-extrabold text-white">Explore our products</AlertTitle>
        <AlertDescription className="text-white/70">
          Protect more than just your code. Explore our other software resilience solutions.
        </AlertDescription>
      </div>
      <Button variant="secondary" onClick={onExploreSolutions}>
        Explore products <ArrowRight />
      </Button>
    </Alert>
  );
};

export default ExploreSolutionsAlert;
